import flatpickr from "flatpickr";
document.addEventListener("DOMContentLoaded", () => {
  // Get the hidden input field with the ID 'StepIndex'
  const stepIndexField = document.getElementById("StepIndex") as HTMLInputElement | null;

  interface RoomDiscountDto {
    Key: string;
    Discount: number;
    DiscountAmount: number;
    Duration: number;
    Message: string;
    DiscountType: string;
    DiscountDurationUnit: string;
    DiscountText: string;
    Link: string;
  }

  interface RoomItemDto {
    RoomKey: string;
    RoomName: string;
    Discounts: RoomDiscountDto[];
  }

  let currentSlide = 2; // Default to the third slide (0-based index)

  // Step 1 logic
  function initializeStep1() {
    console.log(currentSlide);
    const elements = {
      sizeOptions: Array.from(document.querySelectorAll(".size-option")) as HTMLElement[],
      roomSizeEl: document.getElementById("room-size") as HTMLElement | null,
      roomDimensionsEl: document.getElementById("room-dimensions") as HTMLElement | null,
      roomDimensionsMobEl: document.getElementById("room-dimensions-mob") as HTMLElement | null,
      roomContentEl: document.getElementById("room-content") as HTMLElement | null,
      roomContentMobEl: document.getElementById("room-content-mob") as HTMLElement | null,
      roomGif: document.getElementById("room-gif") as HTMLImageElement | null,
      roomKey: document.getElementById("RoomKey") as HTMLInputElement | null,
      roomKeyMob: document.getElementById("room-key-mob") as HTMLInputElement | null,
      roomSizes: document.querySelector(".room-sizes") as HTMLElement | null,
      roomSizesContainer: document.querySelector(".room-sizes-slider") as HTMLElement | null,
      prevBtn: document.querySelector(".prev-btn") as HTMLElement | null,
      nextBtn: document.querySelector(".next-btn") as HTMLElement | null,
    };


    const totalSlides = elements.sizeOptions.length;
    let itemsPerView = 5;
    let sizeOptionWidth = 0;

    const isMobile = (): boolean => window.innerWidth < 576;

    function debounce<T extends (...args: unknown[]) => void>(func: T, wait: number): (...args: Parameters<T>) => void {
      let timeout: number | null = null;
      return (...args: Parameters<T>): void => {
        if (timeout !== null) clearTimeout(timeout);
        timeout = window.setTimeout(() => func(...args), wait);
      };
    }

    function updateRoomInfo(option: HTMLElement): void {
      const roomSize = option.getAttribute("data-size") || "";
      const roomDimensions = option.getAttribute("data-dimensions") || "";
      const roomContent = option.getAttribute("data-content") || "";
      const roomGifDesktop = option.getAttribute("data-gif-desktop") || "";
      const roomGifMobile = option.getAttribute("data-gif-mobile") || "";
      const gifSource = isMobile() ? roomGifMobile : roomGifDesktop;
      const roomKey = option.getAttribute("data-key") || ""; // Add this line

      if (elements.roomSizeEl) elements.roomSizeEl.textContent = roomSize;
      if (elements.roomDimensionsEl) elements.roomDimensionsEl.textContent = roomDimensions;
      if (elements.roomDimensionsMobEl) elements.roomDimensionsMobEl.textContent = roomDimensions;
      if (elements.roomContentEl) elements.roomContentEl.innerHTML = roomContent.replace(/\n/g, "<br>");
      if (elements.roomContentMobEl) elements.roomContentMobEl.innerHTML = roomContent.replace(/\n/g, "<br>");;
      if (elements.roomKey) elements.roomKey.value = roomKey;
      if (elements.roomKeyMob) elements.roomKeyMob.value = roomKey;

      if (elements.roomGif && gifSource) {
        const currentGif = elements.roomGif.src;
        if (currentGif !== gifSource) {
          elements.roomGif.src = gifSource;
        }
      }
    }

    function centerSelectedSlide(): void {
      if (!elements.roomSizesContainer || !elements.roomSizes) return;
      const translateX = Math.min(
        0,
        Math.max(
          -(currentSlide * sizeOptionWidth - elements.roomSizesContainer.clientWidth / 2 + sizeOptionWidth / 2),
          -(totalSlides * sizeOptionWidth - elements.roomSizesContainer.clientWidth)
        )
      );
      elements.roomSizes.style.transform = `translateX(${translateX}px)`;
      elements.roomSizes.style.transition = "transform 0.3s ease";
    }

    function selectCurrentSlide(): void {
      elements.sizeOptions.forEach((opt) => opt.classList.remove("active"));
      const currentOption = elements.sizeOptions[currentSlide];
      currentOption?.classList.add("active");
      updateRoomInfo(currentOption);
      centerSelectedSlide();
    }

    function nextSlide(): void {
      currentSlide = (currentSlide + 1) % totalSlides; // Loop back to the first slide
      selectCurrentSlide();
    }

    function prevSlide(): void {
      currentSlide = (currentSlide - 1 + totalSlides) % totalSlides; // Loop back to the last slide
      selectCurrentSlide();
    }

    function initialize(): void {
      const containerWidth = elements.roomSizesContainer?.clientWidth || 0;
      itemsPerView = window.innerWidth > 992 ? 5 : window.innerWidth > 768 ? 3 : 1;
      sizeOptionWidth = containerWidth / itemsPerView;

      elements.sizeOptions.forEach((option) => {
        option.style.width = `${sizeOptionWidth}px`;
      });

      // Try to find the slide with data-size="25 sq ft"
      const targetOption = elements.sizeOptions.find(
        (option) => option.getAttribute("data-size") === "25 sq ft"
      );

      if (targetOption) {
        currentSlide = elements.sizeOptions.indexOf(targetOption); // Select the found slide
      } else {
        // Ensure we do not default beyond available slides
        if (totalSlides > 2) {
          currentSlide = 2; // Select the third slide if available
        } else {
          currentSlide = totalSlides > 2 ? 2 : totalSlides - 1;
        }
      }

      selectCurrentSlide();
    }


    if (elements.nextBtn) elements.nextBtn.addEventListener("click", nextSlide);
    if (elements.prevBtn) elements.prevBtn.addEventListener("click", prevSlide);

    elements.sizeOptions.forEach((option, index) => {
      option.addEventListener("click", () => {
        currentSlide = index;
        selectCurrentSlide();
      });
    });

    window.addEventListener(
      "resize",
      debounce(() => {
        const previousSlideIndex = currentSlide; // Store the previously selected slide index

        // Update layout-related properties without resetting selection
        const containerWidth = elements.roomSizesContainer?.clientWidth || 0;
        itemsPerView = window.innerWidth > 992 ? 5 : window.innerWidth > 768 ? 3 : 1;
        sizeOptionWidth = containerWidth / itemsPerView;

        elements.sizeOptions.forEach((option) => {
          option.style.width = `${sizeOptionWidth}px`;
        });

        currentSlide = previousSlideIndex; // Restore the previously selected slide
        centerSelectedSlide();
        updateRoomInfo(elements.sizeOptions[currentSlide]); // Keep the selected room's details
      }, 100)
    );

    initialize();
  }



  // Functions moved out of block scope
  function updateFormGroups(form: HTMLFormElement | null): void {
    if (form) {
      const inputs = form.querySelectorAll("input, select, textarea");
      inputs.forEach((input) => {
        const formGroup = input.closest(".form-group");
        if (input.classList.contains("input-validation-error")) {
          formGroup?.classList.add("has-error");
        } else {
          formGroup?.classList.remove("has-error");
        }
      });
    }
  }

  function disableInputsInDisabledGroups(form: HTMLFormElement | null): void {
    if (form) {
      const disabledGroups = form.querySelectorAll(".form-group.disabled");
      disabledGroups.forEach((group) => {
        const inputs = group.querySelectorAll("input, select, textarea");
        inputs.forEach((input) => {
          if (
            input instanceof HTMLInputElement ||
            input instanceof HTMLSelectElement ||
            input instanceof HTMLTextAreaElement
          ) {
            input.disabled = true;
          }
        });
      });
    }
  }

  let delay: number;
  function delayedValidation(form: HTMLFormElement | null): void {
    clearTimeout(delay);
    delay = window.setTimeout(() => {
      updateFormGroups(form);
    }, 300);
  }

  // Step 2 logic
  function initializeStep2(): void {
    const form = document.querySelector("form") as HTMLFormElement | null;
    const preferredStoreSelect = document.getElementById("StorageDetails_PreferredStore") as HTMLSelectElement | null;
    const discountSelect = document.getElementById("StorageDetails_Discount") as HTMLSelectElement | null;
    const durationSelect = document.getElementById("StorageDetails_Duration") as HTMLSelectElement | null;

    // Utility function to get all room elements on the page
    const getAllRooms = () => {
      return Array.from(document.querySelectorAll<HTMLElement>(".room"));
    };

    if (preferredStoreSelect && discountSelect && durationSelect) {
      let selectedStore = "";
      let selectedDuration = "";

      // Prefill logic on page load
      if (preferredStoreSelect && preferredStoreSelect.value) {
        selectedStore = preferredStoreSelect.value;
      }
      if (durationSelect && durationSelect.value) {
        selectedDuration = durationSelect.value;
      }


      const updateDiscountDropdown = () => {
        //console.log("Selected Store:", selectedStore);
        //console.log("Selected Duration:", selectedDuration);

        if (!selectedStore) {
          resetDiscountDropdown("Please select your preferred store first");
          return;
        }

        if (!selectedDuration) {
          resetDiscountDropdown("Please select a duration");
          return;
        }

        const relatedDiv = document.getElementById(selectedStore.replace(/,/g, "").replace(/\s+/g, "-"));
        //console.log("StoreDiscounts: ", relatedDiv);
        if (relatedDiv) {
          const discounts = relatedDiv.getAttribute("data-discounts");

          if (discounts) {
            const discountsArray = JSON.parse(discounts) as {
              DiscountMessage: string;
              Durations: string[];
              Link: string;
            }[];

            if (discountsArray.length === 1) {
              // Handle a single discount
              displaySingleDiscount(discountsArray[0]);

              const hiddenLinkField = document.getElementById("StorageDetails_DiscountLink") as HTMLInputElement | null;
              if (hiddenLinkField && discountsArray[0].Link) {
                hiddenLinkField.value = discountsArray[0].Link;
                console.log(discountsArray[0].Link);
              }
            } else {
              // Handle multiple discounts
              populateDiscountDropdown(discountsArray);

              const matchingDiscount = discountsArray.find((discount) =>
                discount.Durations.includes(selectedDuration)
              );

              if (matchingDiscount) {
                preselectDiscount(matchingDiscount);
              }
            }
          }
        }
      };

      const resetDiscountDropdown = (message: string) => {
        while (discountSelect.options.length > 0) {
          discountSelect.remove(0);
        }

        const option = document.createElement("option");
        option.text = message;
        option.disabled = true;
        option.selected = true;
        discountSelect.add(option);

        discountSelect.disabled = true;

        const discountFormGroup = discountSelect.closest(".form-group");
        if (discountFormGroup) {
          discountFormGroup.classList.add("disabled");
        }

        const discountDisplay = document.getElementById("discount-display");
        if (discountDisplay) {
          discountDisplay.style.display = "none";
        }
      };


      const populateDiscountDropdown = (discountsArray: { DiscountMessage: string; Durations: string[]; Link?: string  }[]) => {
        // Switch back to dropdown mode
        const discountDisplay = document.getElementById("discount-display");
        if (discountDisplay) {
          discountDisplay.style.display = "none";
        }
        discountSelect.style.display = "block";

        while (discountSelect.options.length > 0) {
          discountSelect.remove(0);
        }

        discountsArray.forEach((discount) => {
          const option = document.createElement("option");
          option.value = discount.DiscountMessage; // Use DiscountMessage for selection
          option.text = discount.DiscountMessage; // Display the DiscountMessage
          option.setAttribute("data-durations", JSON.stringify(discount.Durations)); // Store durations in data attribute
          option.setAttribute("data-link", discount.Link || ""); // Store the link in a data attribute
          discountSelect.add(option);
        });

        discountSelect.addEventListener("change", () => {
          const selectedOption = discountSelect.options[discountSelect.selectedIndex];
          const selectedLink = selectedOption.getAttribute("data-link") || "";
          console.log( selectedOption);

          const hiddenLinkField = document.getElementById("StorageDetails_DiscountLink") as HTMLInputElement | null;
          if (hiddenLinkField) {
            hiddenLinkField.value = selectedLink;
            console.log(selectedLink);
          }
        });

        discountSelect.disabled = false;

        const discountFormGroup = discountSelect.closest(".form-group");
        if (discountFormGroup) {
          discountFormGroup.classList.remove("disabled");
        }
      };

      const preselectDiscount = (discount: { DiscountMessage: string; Durations: string[]; Link?: string  }) => {
        const hiddenLinkField = document.getElementById("StorageDetails_DiscountLink") as HTMLInputElement | null;

        discountSelect.value = discount.DiscountMessage;

        console.log("hello");

        if (hiddenLinkField && discount.Link) {
          console.log(discount.Link);
          hiddenLinkField.value = discount.Link; // Set the link value
        }
      };

      const displaySingleDiscount = (discount: { DiscountMessage: string }) => {
        // Switch to text mode
        discountSelect.style.display = "none";
        discountSelect.disabled = true;

        let discountDisplay = document.getElementById("discount-display");
        if (!discountDisplay) {
          discountDisplay = document.createElement("div");
          discountDisplay.id = "discount-display";
          discountDisplay.classList.add("discount-display");
          discountSelect.insertAdjacentElement("afterend", discountDisplay);
        }

        discountDisplay.textContent = discount.DiscountMessage;
        discountDisplay.style.display = "block";

        // Add a hidden input to hold the value of the single discount
        let hiddenDiscountInput = document.getElementById("hidden-discount-input") as HTMLInputElement | null;
        if (!hiddenDiscountInput) {
          hiddenDiscountInput = document.createElement("input");
          hiddenDiscountInput.type = "hidden";
          hiddenDiscountInput.id = "hidden-discount-input";
          hiddenDiscountInput.name = discountSelect.name; // Use the same name as the select element
          discountSelect.insertAdjacentElement("afterend", hiddenDiscountInput);
        }

        hiddenDiscountInput.value = discount.DiscountMessage; // Set the value to the single discount message

        const discountFormGroup = discountSelect.closest(".form-group");
        if (discountFormGroup) {
          discountFormGroup.classList.remove("disabled");
        }
      };
      updateDiscountDropdown();

      const handlePreferredStoreChange = () => {
        selectedStore = preferredStoreSelect.value;

        const rooms = getAllRooms();

        // Get the current room key from the #selectedRoom element
        const currentRoomKey = document.querySelector("#selectedRoom")?.getAttribute("data-room-key");

        if (!currentRoomKey) {
          console.warn("No current room key found in #selectedRoom.");
          return;
        }

        // Find the current room using the room key
        const currentRoomElement = rooms.find(room => room.dataset.roomKey === currentRoomKey);

        if (!currentRoomElement) {
          console.warn("No matching room found for the current room key.");
          return;
        }

        // Get the storage option name from the current room
        const storageOptionName = currentRoomElement.dataset.storageOptionName;

        if (!storageOptionName) {
          console.warn("No storage option name found for the current room.");
          return;
        }

        // Find the corresponding room in the selected store
        const storeRooms = document
          .getElementById("K_" + selectedStore.replace(/,/g, "").replace(/\s+/g, "-"))
          ?.querySelectorAll<HTMLElement>(".room");
        const correspondingRoom = Array.from(storeRooms || []).find(
          room => room.dataset.storageOptionName === storageOptionName
        );

        if (!correspondingRoom) {
          console.warn("No corresponding room found in the selected store.");
          return;
        }

        // Update the #RoomKey input with the new room key
        const roomKeyField = document.querySelector("#RoomKey") as HTMLInputElement | null;
        console.log(roomKeyField);
        if (roomKeyField) {
          roomKeyField.value = correspondingRoom.dataset.roomKey || "";
          console.log(`Updated RoomKey to: ${roomKeyField.value}`);
        }


        updateDiscountDropdown();
      };

      const handleDurationChange = () => {
        selectedDuration = durationSelect.value;
        updateDiscountDropdown();
      };

      handlePreferredStoreChange();

      preferredStoreSelect.addEventListener("change", handlePreferredStoreChange);
      durationSelect.addEventListener("change", handleDurationChange);

      form?.addEventListener("submit", function (event) {
        event.preventDefault();



        // console.log("hello");
        // if (!form.checkValidity()) {
        //   updateFormGroups(form);
        //   console.log("form is invalid!");
        //   return; // Do not proceed if the form is invalid
        // }

        const submitButton = form.querySelector("button[type=\"submit\"]") as HTMLButtonElement | null;
        if (submitButton) {
          submitButton.innerHTML = "<span class=\"spinner-border spinner-border-sm\" role=\"status\" aria-hidden=\"true\"></span>&nbsp; Fetching your quote..";
          submitButton.disabled = true;
          //form?.submit();
        }

        // Add a 2-second delay
        setTimeout(() => {
          const hasErrors = document.querySelectorAll(".field-validation-error").length > 0;

          if (hasErrors) {
            console.log("Form is invalid, errors found!");
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.innerHTML = "Get Your Quote"; // Reset the button
            }
            return; // Stop further execution
          }

          console.log("Form is valid, proceeding with submission...");
          if (submitButton) {
            submitButton.innerHTML = "<span class=\"spinner-border spinner-border-sm\" role=\"status\" aria-hidden=\"true\"></span>&nbsp; Fetching your quote..";
          }

          form.submit(); // Submit the form if no errors
        }, 500); // 2-second delay


      });

      form?.addEventListener("input", function () {
        delayedValidation(form);
      });

      form?.addEventListener("change", function () {
        delayedValidation(form);
      });

      disableInputsInDisabledGroups(form);
    }
  }





function getSelectedDiscount(): RoomDiscountDto{

  const discountLink = document.getElementById("StorageDetails_DiscountLink") as HTMLInputElement;
  const discountKeyEl = document.getElementById("chosenDiscount") as HTMLInputElement | null;
  const roomKeyEl = document.getElementById("RoomKey") as HTMLInputElement | null;
  const roomKey = roomKeyEl?.value ?? "";


  const roomDiscountsData = document.getElementById("roomDiscounts")?.getAttribute("data-discount-rooms");
  const roomDiscounts = roomDiscountsData ? JSON.parse(roomDiscountsData) : [];

  const selectedDiscount = discountKeyEl?.getAttribute("data-discount-key");

  // Find the matching room
  const matchingRoom = roomDiscounts.find((room: RoomItemDto) => room.RoomKey === roomKey);

  let matchingDiscount = undefined;

  if (matchingRoom) {
    console.log(matchingRoom);
    // Find the first discount with a matching link
    matchingDiscount = matchingRoom.Discounts.find((discount: RoomDiscountDto) =>
      discount.Key.toString() === selectedDiscount
    );
    if (!matchingDiscount) {
      matchingDiscount = matchingRoom.Discounts.find((discount: RoomDiscountDto) =>
        discount.Link.toString() === discountLink.value
      );
    }
  }

    return matchingDiscount;

}







  function initializeStep3(): void {
    const roomDiscountsData = document.getElementById("roomDiscounts")?.getAttribute("data-discount-rooms");
    const roomDiscounts = roomDiscountsData ? JSON.parse(roomDiscountsData) : [];
    const discountLink = document.getElementById("StorageDetails_DiscountLink") as HTMLInputElement;
    const discountText = document.getElementById("StorageDetails_Discount") as HTMLInputElement;
    //const storageDuration = document.getElementById("StorageDetails_Duration") as HTMLInputElement;
    const discountDurationWeeks = document.getElementById("discount-duration-weeks");

    console.log(roomDiscounts);

    const sizeOptions = Array.from(document.querySelectorAll<HTMLElement>(".size-option"));
    const roomSizesContainer = document.querySelector<HTMLElement>(".room-sizes-slider"); // Visible viewport
    const roomSizes = document.querySelector<HTMLElement>(".room-sizes"); // Contains all slides
    const roomSizeEl = document.getElementById("room-size");
    const roomDimensionsEl = document.getElementById("room-dimensions");
    const roomDimensionsMobEl = document.getElementById("room-dimensions-mob");
    const roomContentEl = document.getElementById("room-content");
    const roomContentMobEl = document.getElementById("room-content-mob");
    const roomGif = document.getElementById("room-gif") as HTMLImageElement | null;
    const roomKey = document.getElementById("RoomKey") as HTMLInputElement | null;
    const roomKeyMob = document.getElementById("room-key-mob") as HTMLInputElement | null;
    const prevBtn = document.querySelector<HTMLElement>(".prev-btn");
    const nextBtn = document.querySelector<HTMLElement>(".next-btn");
    const roomPrice = document.getElementById("weekly-non-offer-price");
    const roomOfferPrice = document.getElementById("weekly-offer-price");
    const roomNonOfferPriceContainer = document.getElementById("non-offer-price-container");
    const roomSpecialOfferPrice = document.getElementById("weekly-special-offer-price");
    const discountAmountEl = document.getElementById("discountAmount");
    const discountDurationEl = document.getElementById("discountAmount");
    const discountKeyEl = document.getElementById("chosenDiscount") as HTMLInputElement | null;
    const startDateInput = document.getElementById("StartDate");
    const emailQuoteButton = document.getElementById("email-quote") as HTMLElement | null;
    const form = document.getElementById("memorySpaceForm") as HTMLFormElement | null;

    const discountUnitSingularEl = document.getElementById("discount-unit-singular");
    const discountUnitEl = document.getElementById("discount-unit");

    // Retrieve the email URL from the data attribute in the #email-url div
    const emailUrlEl = document.getElementById("email-url") as HTMLElement | null;
    const emailUrl = emailUrlEl?.getAttribute("data-email-url");

    if (startDateInput) {

      flatpickr(startDateInput, {
        minDate: "today",  // Prevent past dates
        dateFormat: "d/m/Y",  // Display format for the user
        allowInput: true,
        onChange: (selectedDates: Date[]) => {
          if (selectedDates[0]) {
            // Convert the selected date to YYYY-MM-DD for form submission
            const formattedDate = selectedDates[0].toISOString().split("T")[0];
            startDateInput.setAttribute("data-formatted-value", formattedDate);  // Store formatted date in a data attribute
          }
        }
      });

      // Handle form submission
      const form = document.querySelector("form");  // Ensure this selects your form
      if (form) {
        form.addEventListener("submit", () => {
          // Before submission, set the value of the input to the formatted date
          const formattedDate = startDateInput.getAttribute("data-formatted-value");
          if (formattedDate) {
            (startDateInput as HTMLInputElement).value = formattedDate;  // Override the visible input value with the formatted one
          }
        });
      }

    }

    // Select the video container (replace '.video-container' with your actual selector)
    const videoContainer = document.querySelector<HTMLElement>(".room-video-container");

    let currentSlide = 0;
    const totalSlides = sizeOptions.length;
    let itemsPerView = 3; // Default to showing 3 items per view

    // Dynamically update the number of visible items based on screen width
    function updateItemsPerView(): number {
      const containerWidth = window.innerWidth;

      if (containerWidth > 992) {
        return 3; // Desktop
      } else {
        return 1; // Mobile
      }
    }
    function updateRoomDiscounts(roomKey: string): void {
      console.log(roomDiscounts);
      console.log(discountLink);
      if (!roomDiscounts || !discountLink) return;


      const selectedDiscount = discountKeyEl?.getAttribute("data-discount-key");

      // Find the matching room
      const matchingRoom = roomDiscounts.find((room: RoomItemDto) => room.RoomKey === roomKey);

      if (matchingRoom) {
        console.log(matchingRoom);
        // Find the first discount with a matching link
        let matchingDiscount = matchingRoom.Discounts.find((discount: RoomDiscountDto) =>
          discount.Key.toString() === selectedDiscount
        );
        if(!matchingDiscount)
        {
          matchingDiscount = matchingRoom.Discounts.find((discount: RoomDiscountDto) =>
            discount.Link.toString() === discountLink.value
          );
        }

        console.log(matchingDiscount);

        if (matchingDiscount) {
          // Update the storage duration field
          // if (storageDuration) {
          //   storageDuration.value = matchingDiscount.Duration.toString();
          // }

          // Update the discount duration on the UI
          //this says weeks but it's weeks and months
          if (discountDurationWeeks) {
            console.log(matchingDiscount);

            if(matchingDiscount.DiscountDurationUnit == "Months")
            {
              const duration = (matchingDiscount.Duration / 4);
              discountDurationWeeks.textContent = duration.toString();

              if(discountUnitEl)
              {
                let unit = "month";

                if(discountUnitSingularEl)
                {
                  discountUnitSingularEl.textContent = unit.toLowerCase();
                }

                console.log(duration);

                if(duration > 1)
                {
                  unit += "s";
                }
                discountUnitEl.textContent = unit.toLowerCase();
              }


              //HERE SWAP OUT THE TEXT
            }
            else{
              discountDurationWeeks.textContent = matchingDiscount.Duration.toString();

            }
            discountText.value = matchingDiscount.DiscountText;
          }

          // Update the discount value in the DOM
          const discountAmountEl = document.getElementById("discountAmount");
          if (discountAmountEl) {
            discountAmountEl.setAttribute("data-discount", matchingDiscount.Discount.toString());
          }



          // Update the discount-banner text
          const discountBannerBig = document.querySelector(".discount-banner .big");
          const discountBannerSmall = document.querySelector(".discount-banner .small");
          const statementMessage = matchingDiscount.Message || "";

          const messageParts = statementMessage.split(":");
          const bigText = messageParts.length === 2 ? messageParts[0].trim() : statementMessage;
          const smallText = messageParts.length === 2 ? messageParts[1].trim() : "";

          if (discountBannerBig) {
            discountBannerBig.textContent = bigText;
          }
          if (discountBannerSmall) {
            discountBannerSmall.textContent = smallText;
          }
        }
      }
    }


    function updateRoomInfo(option: HTMLElement): void {
      const roomSize = option.getAttribute("data-size") || "";
      const roomDimensions = option.getAttribute("data-dimensions") || "";
      const roomContent = option.getAttribute("data-content") || "";
      const roomGifDesktop = option.getAttribute("data-gif-desktop") || "";
      const roomGifMobile = option.getAttribute("data-gif-mobile") || "";
      const gifSource = window.innerWidth < 576 ? roomGifMobile : roomGifDesktop; // Select based on screen size
      const roomKeyValue = option.getAttribute("data-key") || "";
      const roomPriceValue = option.getAttribute("data-price") || "";
      const roomOfferPriceValue = option.getAttribute("data-offer-price") || "";

      updateRoomDiscounts(sizeOptions[currentSlide].getAttribute("data-key") || "");


      if (roomSizeEl) roomSizeEl.textContent = roomSize;
      if (roomDimensionsEl) roomDimensionsEl.textContent = roomDimensions;
      if (roomDimensionsMobEl) roomDimensionsMobEl.textContent = roomDimensions;
      if (roomContentEl) roomContentEl.innerHTML = roomContent.replace(/\n/g, "<br>");
      if (roomContentMobEl) roomContentMobEl.innerHTML = roomContent.replace(/\n/g, "<br>");
      if (roomKey) roomKey.value = roomKeyValue;
      if (roomKeyMob) roomKeyMob.value = roomKeyValue;
      if (roomPrice && roomOfferPrice && roomNonOfferPriceContainer) {
        if (parseFloat(roomOfferPriceValue) > 0) {
          roomOfferPrice.textContent = roomOfferPriceValue;
          roomPrice.textContent = roomPriceValue;
          roomNonOfferPriceContainer.style.display = "block";
        } else {
          roomOfferPrice.textContent = roomPriceValue;
          roomNonOfferPriceContainer.style.display = "none";
        }

        const selectedDiscount = getSelectedDiscount();

        if (discountAmountEl && discountDurationEl && roomSpecialOfferPrice) {
          const discountAmount = discountAmountEl.getAttribute("data-discount") || "";
          let price = 0.00;

          if (parseFloat(roomOfferPriceValue) > 0) {
            price = parseFloat(roomOfferPriceValue) * (1 - parseFloat(discountAmount) / 100);
          } else {
            price = parseFloat(roomPriceValue) * (1 - parseFloat(discountAmount) / 100);
          }

          price = Math.round(price * 100) / 100;

          if(selectedDiscount.DiscountType == "Fixed Price")
          {
            price = selectedDiscount.DiscountAmount;
          }


          roomSpecialOfferPrice.innerText = Number.isInteger(price)
            ? price.toString()
            : price.toFixed(2);

        }

      }
      if (roomGif && gifSource) {
        const currentGif = roomGif.src;
        if (currentGif !== gifSource) {
          roomGif.src = gifSource;
        }
      }
    }

    function selectCurrentSlide(): void {
      sizeOptions.forEach((opt) => opt.classList.remove("active"));
      const currentOption = sizeOptions[currentSlide];
      currentOption.classList.add("active");
      if(emailQuoteButton)
      {
        emailQuoteButton.textContent = "Email this quote";
      }
      updateRoomInfo(currentOption);
    }

    function updateVisibleItems(): void {
      if (!roomSizes || !roomSizesContainer) return;

      const sizeOptionWidth = roomSizes.scrollWidth / totalSlides;
      const containerWidth = roomSizesContainer.clientWidth;

      // Get the current translateX value or default to 0
      const transformValue = roomSizes.style.transform || "translateX(0px)";
      const visibleStart =
        Math.abs(parseFloat(transformValue.replace("translateX(", "").replace("px)", ""))) || 0;
      const visibleEnd = visibleStart + containerWidth;

      sizeOptions.forEach((option, index) => {
        const optionStart = index * sizeOptionWidth;
        const optionEnd = optionStart + sizeOptionWidth;

        if (optionEnd > visibleStart && optionStart < visibleEnd) {
          option.classList.add("visible");
        } else {
          option.classList.remove("visible");
        }
      });
    }

    function scrollToVisible(): void {
      if (!roomSizes || !roomSizesContainer) return;

      const sizeOptionWidth = roomSizes.scrollWidth / totalSlides;
      const containerWidth = roomSizesContainer.clientWidth;
      const totalContentWidth = roomSizes.scrollWidth;

      // Calculate the new translateX to bring the current slide into view
      let newTranslateX =
        currentSlide * sizeOptionWidth - (containerWidth - sizeOptionWidth) / 2;

      if (totalContentWidth <= containerWidth) {
        // Content fits within the container, center the content
        newTranslateX = 0;
        roomSizes.style.justifyContent = "center";
      } else {
        // Content overflows the container, scroll as needed
        roomSizes.style.justifyContent = "flex-start";

        // Calculate the maximum translateX value
        const maxTranslateX = totalContentWidth - containerWidth;

        // Clamp newTranslateX between 0 and maxTranslateX
        newTranslateX = Math.max(0, Math.min(newTranslateX, maxTranslateX));
      }

      roomSizes.style.transform = `translateX(-${newTranslateX}px)`;
      roomSizes.style.transition = "transform 0.3s ease";

      updateVisibleItems();
    }

    function findAndSelectOptionByKey(key: string): void {
      const index = sizeOptions.findIndex((option) => option.getAttribute("data-key") === key);
      if (index !== -1) {
        currentSlide = index;
        selectCurrentSlide();
        scrollToVisible();
      }
    }

    // Check the RoomKey value on page load and select the corresponding option
    if (roomKey && roomKey.value) {
      findAndSelectOptionByKey(roomKey.value);
    } else {
      selectCurrentSlide();
      scrollToVisible();
    }

    // Dynamically adjust size options' width and re-render slider on window resize
    function updateSizeOptionWidths(): void {
      itemsPerView = updateItemsPerView();
      const containerWidth = roomSizesContainer?.clientWidth || 0;
      const sizeOptionWidth = containerWidth / itemsPerView;

      sizeOptions.forEach((option) => {
        option.style.width = `${sizeOptionWidth}px`;
      });

      // Adjust the slider when resizing window
      scrollToVisible();

      // Update min-height on resize
      if (videoContainer) {
        const height = videoContainer.offsetHeight;
        videoContainer.style.minHeight = `${height}px`;
      }
    }

    function nextSlide(): void {
      currentSlide = (currentSlide + 1) % totalSlides; // Loop back to the first slide
      selectCurrentSlide();
      scrollToVisible();
    }

    function prevSlide(): void {
      currentSlide = (currentSlide - 1 + totalSlides) % totalSlides; // Loop back to the last slide
      selectCurrentSlide();
      scrollToVisible();
    }

    // Event listeners for next and previous buttons
    if (nextBtn) {
      nextBtn.addEventListener("click", nextSlide);
    }
    if (prevBtn) {
      prevBtn.addEventListener("click", prevSlide);
    }

    // Option click listener to select and scroll if necessary
    sizeOptions.forEach((option, index) => {
      option.addEventListener("click", () => {
        currentSlide = index;
        selectCurrentSlide();
        scrollToVisible();
      });
    });

    // Initialize the slider
    selectCurrentSlide();
    updateSizeOptionWidths();
    updateVisibleItems();

    // Recalculate sizes and re-render slider on window resize
    window.addEventListener("resize", updateSizeOptionWidths);

// Email Quote Functionality
    if (emailQuoteButton && form && emailUrl) {
      emailQuoteButton.addEventListener("click", (e: Event) => {
        e.preventDefault(); // Prevent default form submission

        // Update the button text and add a spinner
        emailQuoteButton.innerHTML = "<span class=\"spinner-border spinner-border-sm\" role=\"status\" aria-hidden=\"true\"></span>&nbsp; Sending quote..";
        //emailQuoteButton.disabled = true; // Disable the button while processing

        const formData = new FormData(form); // Capture form data

        // Use the email URL from the data-email-url attribute
        fetch(emailUrl, {
          method: "POST",
          body: formData
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json(); // Assuming the server returns JSON data
          })
          .then((data) => {
            console.log(data); // For debugging or handling the returned data

            // Update form fields with the corresponding values from the response
            const idField = document.getElementById("Id") as HTMLInputElement | null;
            const storageDetailsIdField = document.getElementById("StorageDetails_Id") as HTMLInputElement | null;
            const personalDetailsIdField = document.getElementById("PersonalDetails_Id") as HTMLInputElement | null;
            const quoteGuidField = document.getElementById("QuoteGuid") as HTMLInputElement | null;

            if (idField) idField.value = data.id || "";
            if (storageDetailsIdField) storageDetailsIdField.value = data.storageDetails.id || "";
            if (personalDetailsIdField) personalDetailsIdField.value = data.personalDetails.id || "";
            if (quoteGuidField) quoteGuidField.value = data.quoteGuid || "";

            // Update the button text to indicate the email was sent
            if (emailQuoteButton) {
              emailQuoteButton.textContent = "Quote Sent";
            }

            // Handle room change (reset the button text if necessary)
            sizeOptions.forEach((option) => {
              option.addEventListener("click", () => {

              });
            });

          })
          .catch((error) => {
            console.error("There was a problem with the request:", error);
          });
      });
    }

  }







  // Step Initialization
  if (stepIndexField) {
    const stepIndexValue: string = stepIndexField.value;

    if (stepIndexValue === "1") {
      initializeStep1();

      //window.addEventListener("resize", initializeStep1);
    } else if (stepIndexValue === "2") {
      initializeStep2();
    } else if (stepIndexValue === "3") {
      initializeStep3();
    }

  } else {
    console.warn("StepIndex field not found.");
  }
});
